import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core'

@Component({
  selector: 'lla-auth-layout',
  templateUrl: './auth-layout.component.html',
  styleUrls: ['./auth-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AuthLayoutComponent implements OnInit, OnDestroy {
  ngOnInit(): void {
    document.body.classList.add('bg-primary')
  }

  ngOnDestroy(): void {
    document.body.classList.remove('bg-primary')
  }
}
